import Timestamp from './main';
import type { TimestampStyles, Props } from './types';
import { getADGTimestampDisplaySetting } from './utils';

export type { TimestampStyles, Props };
export default Timestamp;
export { getADGTimestampDisplaySetting };
